import StoreDefinition from '../StoreDefinition'
import { api } from '../../plugins/axios'
import ActionHandler from '../../lib/ActionHandler'

let _execEndpoint = '/api/v1/embed/steps/execute'

export function useOpenEndpoint () {
  _execEndpoint = '/api/v1/embed/steps/execute-vault-auth'
}

export default new StoreDefinition()
  .prop('stepState', {})
  .prop('currentStepIndex', 0)
  .action('consumeState', ({ commit, getters }, item) => {
    const state = getters.stepState
    delete state[item]

    commit('setStepState', state)
  })
  .action('mergeToState', ({ commit, getters }, update) => {
    const state = Object.assign({}, getters.stepState, update)

    commit('setStepState', state)
  })
  .action('execute', ({ dispatch, getters }) => {
    return api.post(_execEndpoint, {
      state: getters.stepState
    }, {
      headers: {
        'X-SCP-EMBED-STEP': getters.currentStepIndex
      }
    })
      .then(res => {
        // execute actions if we have some
        ActionHandler.run(res.data.actions)

        // store the state
        dispatch('setStepState', res.data.state)

        // set the next index
        dispatch('setCurrentStepIndex', res.headers['x-scp-embed-next-step'] || null)

        return res.data.state
      })
  })
  .end()
